import React, { useEffect, useState } from "react";
import useCommonFetch from "../../../../hooks/useCommonFetch";
import { getDepartmentList } from "../../../../services/workspace/department.service";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonTable from "../../../components/table/table";
import BottomDrawer from "../../common/drawer/bottomDrawer";
import DefaultSearchSelectInput from "../../../components/inputs/defaultSearchSelectInput";
import DefaultButton from "../../../components/buttons/defaultButton";
import img from "../../../assets/images/profile-sample.jpg";
import { saveEmployeeSalarySetup } from "../../../../services/workspace/payroll.service";
import { _Salary_type, convertToLabelValue } from "../../../../utils/common";
import DefaultInput from "../../../components/inputs/defaultInput";
import toast from "react-hot-toast";
import { getUserList } from "../../../../services/workspace/user.service";
import { getDesignationList } from "../../../../services/workspace/designation.service";

const EmployeeSalarySetup = () => {
  const [isOpenSheet, setIsOpenSheet] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState("");
  const [selectedDesignationId, setSelectedDesignationId] = useState("");
  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([]);

  const breadcrumbs = [{ label: "Employee Salary Setup", path: "" }];

  const {
    data: tableData,
    total: totalData,
    currentPage,
    search,
    handleSearchChange,
    handlePageChange,
    fetchData,
    sortingUIProps,
    applyFilters,
    clearFilters,
  } = useCommonFetch(getUserList, {
    dataPath: "user.data",
    totalPath: "user.meta.total",
    errorMessage: "Failed to fetch user data!",
    debounceDelay: 500,
    customParams: {
      with: "department,designation",
    },
    sortingOptions: [
      { label: "Name", field: "name" },
      { label: "Date of joining", field: "joining_at" },
    ],
    filterModule: "salarySetup",
    sortingModule: "salarySetup",
    orderParamNames: {
      orderByKey: "order_by",
      orderTypeKey: "order_type",
      includeDisabledKey: "includeDisabled",
    },
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,

    dataTransformer: (data) => {
      if (!Array.isArray(data)) return { data: [], action: {} };
      const transformedData = data.map((item) => ({
        id: { data: item?.uuid, variant: "text" },
        name: {
          data: {
            name: item?.name ?? "Unknown",
            email: item?.email ?? "",
            id: item?.code ?? "N/A",
            image: item?.photo || null,
            link: item?.uuid ? `/staff/${item.uuid}` : "#",
          },
          variant: "profile",
        },
        designation: { data: item?.designation?.name, variant: "text" },
        joining_at: { data: item?.joining_at, variant: "date" },

        basic_salary: { data: item?.salary?.basic_salary, variant: "text" },
        salary_type: {
          data:
            _Salary_type.find(
              (type) => type.value === item?.salary?.salary_type
            )?.label || "",
          value: item?.salary?.salary_type,
          variant: "select",
          options: _Salary_type,
        },
        department: { data: item?.department?.name, variant: "text" },
        phone: { data: item?.phone || "N/A", variant: "text" },
      }));

      return {
        data: transformedData,
        action: {
          view: (item) => {
            setSelectedUserData(item);
            setIsOpenSheet(true);
          },
          edit: (item) => {
            setSelectedUserData(item);
            setIsOpenSheet(true);
          },
        },
      };
    },
  });

  const TableHeaderData = [
    { label: "Staff Name", key: "name" },
    { label: "Department", key: "department" },
    { label: "Designation", key: "designation" },
    { label: "Joining Date", key: "joining_at" },
    { label: "Salary Type", key: "salary_type" },
    { label: "Basic Salary", key: "basic_salary" },
  ];

  const fetchDepartment = () => {
    getDepartmentList({})
      .then((response) => {
        setDepartmentList(
          convertToLabelValue(response.department.data || []) || []
        );
      })
      .catch((error) => {
        toast.error("Failed to fetch department data!");
      });
  };

  const fetchDesignation = (departmentId) => {
    if (!departmentId) {
      setDesignationList([]);
      return;
    }

    getDesignationList({ department_id: departmentId })
      .then((response) => {
        setDesignationList(
          convertToLabelValue(response.designation.data || []) || []
        );
      })
      .catch((error) => {
        toast.error("Failed to fetch designation data!");
        console.error(error);
      });
  };

  useEffect(() => {
    fetchDepartment();
  }, []);

  useEffect(() => {
    fetchDesignation(selectedDepartmentId);
  }, [selectedDepartmentId]);

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        filter
        shorting
        breadcrumbs={breadcrumbs}
        sortingModule="salarySetup"
        onSortingChange={sortingUIProps?.onSortingChange}
        sortingProps={sortingUIProps}
        filterProps={{
           filterModule: "salarySetup",
          onFilterChange: () =>
            applyFilters({
              department_id: selectedDepartmentId || undefined,
              designation_id: selectedDesignationId || undefined,
            }),
          onClearFilters: () => {
            setSelectedDepartmentId("");
            setSelectedDesignationId("");
            clearFilters();
          },
          hasActiveFilters: !!selectedDepartmentId || !!selectedDesignationId,
        }}
      >
        <div className=" flex flex-col gap-2 ">
          <div className="">
            <label className="block text-sm font-medium text-gray-700">
              Department
            </label>
            <select
              className="w-full border border-gray-300 rounded-md p-2 text-sm"
              value={selectedDepartmentId}
              onChange={(e) => setSelectedDepartmentId(e.target.value)}
            >
              <option value="">All</option>
              {Array.isArray(departmentList) &&
                departmentList.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
            </select>
          </div>

          <div className="">
            <label className="block text-sm font-medium text-gray-700">
              Designation
            </label>
            <select
              className="w-full border border-gray-300 rounded-md p-2 text-sm"
              value={selectedDesignationId}
              onChange={(e) => setSelectedDesignationId(e.target.value)}
            >
              <option value="">All</option>
              {Array.isArray(designationList) &&
                designationList.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </PageTableHeader>

      <CommonTable
      search={search}
        TableHeaderData={TableHeaderData}
        tabledata={tableData.data}
        currentPage={currentPage}
        totalData={totalData}
        setCurrentPage={handlePageChange}
        loading={false}
        action={tableData.action}
      />

      <BottomDrawer
        isOpen={isOpenSheet}
        setIsOpen={() => setIsOpenSheet(false)}
        title="Employee Salary Setup"
        classNames="!w-[600px]"
        position="right"
      >
        <AddEmployeeSalary
          userData={selectedUserData}
          setIsOpenSheet={setIsOpenSheet}
          fetchData={fetchData}
        />
      </BottomDrawer>
    </div>
  );
};

const AddEmployeeSalary = ({
  userData,
  setIsOpenSheet,
  fetchData,
}) => {
  const [salaryType, setSalaryType] = useState(
    userData?.salary_type?.value
      ? _Salary_type.find(
          (type) => type.value === userData.salary_type.value
        ) || ""
      : ""
  );
  const [basicSalary, setBasicSalary] = useState(
    userData?.basic_salary?.data || ""
  );

  useEffect(() => {
    setSalaryType(
      userData?.salary_type?.value
        ? _Salary_type.find(
            (type) => type.value === userData.salary_type.value
          ) || ""
        : ""
    );

    setBasicSalary(userData?.basic_salary?.data || "");
  }, [userData]);

  const handleSave = async () => {
    const salaryTypeValue =
      salaryType && typeof salaryType === "object" ? salaryType.value : salaryType;

    const payload = {
      salary_type: salaryTypeValue,
      basic_salary: basicSalary,
    };

    saveEmployeeSalarySetup(userData?.id?.data, payload)
      .then(() => {
        toast.success("Salary setup saved successfully!");
        setIsOpenSheet(false);

        fetchData(
          {
            with: "department,designation",
          },
          true
        );
      })
      .catch(() => {
        toast.error("Failed to save salary setup!");
      });
  };

  return (
    <div className="w-full overflow-y-auto">
      <div className="flex gap-4 items-center border-b pb-4 border-gray-200">
        <div className="overflow-hidden w-20 rounded-full">
          <img
            src={userData?.name?.data?.image || img}
            alt="profile"
            className="object-cover"
          />
        </div>
        <div className="w-full">
          <h3 className="text-2xl font-bold text-primary-900">
            {userData?.name?.data?.name || "N/A"}
          </h3>
          <div className="flex flex-row justify-between items-center">
            <p className="text-gray-600 text-sm">
              Email:{" "}
              <span className="text-primary-800">
                {userData?.name?.data?.email || "N/A"}
              </span>
            </p>
            <p className="text-gray-600 text-sm">
              Phone:{" "}
              <span className="text-primary-800">
                {userData?.phone?.data || "N/A"}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6 text-sm text-gray-700 border-b pb-4">
        <div>
          <span className="text-gray-500">Department</span>
          <div className="font-medium">
            {userData?.department?.data || "N/A"}
          </div>
        </div>
        <div>
          <span className="text-gray-500">Designation</span>
          <div className="font-medium">
            {userData?.designation?.data || "N/A"}
          </div>
        </div>
        <div>
          <span className="text-gray-500">Date Of Joining</span>
          <div className="font-medium flex items-center space-x-2">
            <span>📅</span>
            <span>{userData?.joining_at?.data || "N/A"}</span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <DefaultSearchSelectInput
          label="Salary Type"
          options={_Salary_type}
          value={salaryType}
          onChange={setSalaryType}
          placeholder="Select salary type"
        />
        <DefaultInput
          label="Basic Salary"
          value={basicSalary}
          onChange={(e) => setBasicSalary(e.target.value)}
          placeholder="Enter basic salary"
        />
      </div>

      <div className="mt-6 flex justify-start">
        <DefaultButton name="Save" onClick={handleSave} />
      </div>
    </div>
  );
};

export default EmployeeSalarySetup;
